export default __webpack_public_path__ + "static/media/transfacil_galery_10.3d74e123.jpg";